import request from '../../../../shared/request'
import queryString from 'qs'
import _ from 'lodash'

export function getJobList(filters) {
  const qs = queryString.stringify(filters)
  return request(`/reports/maintenance-dob/targeted-monthly-visits-report/job-list?${qs}`)
}

export function getFullReport(filters) {
  const params = _.omit(filters, 'date_range')

  const qs = queryString.stringify(params)
  return request(`/reports/maintenance-dob/targeted-monthly-visits-report/full-report?${qs}`)
}



// WEBPACK FOOTER //
// ./src/redux/api/reports/maintenance_dob/targetedMonthlyVisitsReport.js